import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useSecurity } from '../../context/SecurityContext';
import { useAdminPermissions } from '../../hooks/useAdminPermissions';

const AdminRouteGuard = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, isInitializing } = useSecurity();
  const { canAccessRoute, roleReady } = useAdminPermissions();

  useEffect(() => {
    if (isInitializing || !isAuthenticated || !roleReady) return;
    if (!canAccessRoute(location.pathname)) {
      navigate('/admin/dashboard', { replace: true });
      Swal.fire({
        icon: 'info',
        title: 'Sin permiso',
        text: 'Tu rol no tiene acceso a esta sección del panel.',
        confirmButtonColor: '#00a1ff',
      });
    }
  }, [location.pathname, isInitializing, isAuthenticated, roleReady, canAccessRoute, navigate]);

  if (!roleReady) return children;
  if (!canAccessRoute(location.pathname)) return null;
  return children;
};

export default AdminRouteGuard;
